<template>
    <div class="quotes-small-card-container" :class="[skin, 'local-' + lang]">
        <!-- 视觉模版1 -->
        <div class="type-1" v-if="styleType === '1'">
            <div class="top" @click="jumpStockQuotePage($event)">
                <div class="name">
                    <span class="market" :class="labelColor">{{ label }}</span>
                    <p>{{ name }}</p>
                </div>
            </div>
            <p class="lights">{{ highlights }}</p>

            <div class="gain">
                <div class="data">
                    <!-- <p class="rate"
                        :class="{
                            green:
                                (chgData < 0 && increaseTypeLang === 'cn') ||
                                (chgData > 0 &&
                                    (increaseTypeLang === 'us' ||
                                        increaseTypeLang === 'hk')),
                            gray: chgData === 0,
                            red:
                                (chgData > 0 && increaseTypeLang === 'cn') ||
                                (chgData < 0 &&
                                    (increaseTypeLang === 'us' ||
                                        increaseTypeLang === 'hk'))
                        }"
                    > -->
                    <p class="rate" :class="[rateStyle]" :style="dataStyle">
                        {{ chgStr }}
                    </p>
                    <p class="des">
                        {{ increaseName }}
                    </p>
                </div>

                <!-- 添加自选 -->
                <template v-if="btnType === 'btn_type_txt'">
                    <div
                        class="addBtn btnTxt btnWatch btnWatch-sub-plus"
                        :class="'has-' + btnColor"
                        v-if="hasSubscribe"
                        @click="subscribeHandler"
                    >
                        <i class="plus"></i>
                        <span v-if="hasSubscribe" class="align-center">已添加</span>
                    </div>
                    <div class="addBtn btnTxt btnWatch" :class="btnColor" v-else @click="subscribeHandler">
                        <i class="plus"></i>
                        <span v-if="increaseTypeLang === 'cn'" class="align-center">添加自选</span>
                        <span v-else class="align-center">添加自選</span>
                    </div>
                </template>
                <!-- watchlist
                    :style="{ backgroundImage: `url(${buttonImageUrl})` }"-->
                <div
                    v-else-if="btnType === 'btn_type_watchlist_plus'"
                    class="addBtn btnWatch bgImg"
                    :class="[hasSubscribe ? 'btnWatch-sub-plus has-' + btnColor : btnColor]"
                    @click="subscribeHandler"
                >
                    <i class="plus"></i>
                    <!-- {{btnType}} -->
                    <p class="align-center">{{ hasSubscribe ? 'Added' : 'Watchlist' }}</p>
                </div>

                <div
                    v-else
                    class="addBtn btnWatch bgImg"
                    :class="[hasSubscribe ? 'btnWatch-sub has-' + btnColor : btnColor]"
                    @click="subscribeHandler"
                >
                    <i class="heart"></i>
                    <p class="align-center">{{ hasSubscribe ? 'Added' : 'Watchlist' }}</p>
                </div>
            </div>
        </div>

        <!-- 视觉模版2 -->
        <div class="type-1" v-if="styleType === '2'">
            <div class="top" @click="jumpStockQuotePage($event)">
                <h6 class="name">
                    <span class="market" :class="labelColor">{{ label }}</span>
                    {{ name }}
                </h6>
            </div>

            <div class="gain">
                <div class="data">
                    <!-- <p class="rate"
                        :class="{
                            green:
                                (chgData < 0 && increaseTypeLang === 'cn') ||
                                (chgData > 0 &&
                                    (increaseTypeLang === 'us' ||
                                        increaseTypeLang === 'hk')),
                            gray: chgData === 0,
                            red:
                                (chgData > 0 && increaseTypeLang === 'cn') ||
                                (chgData < 0 &&
                                    (increaseTypeLang === 'us' ||
                                        increaseTypeLang === 'hk'))
                        }"
                    > -->
                    <p class="rate" :class="[rateStyle]" :style="dataStyle">
                        {{ chgStr }}
                    </p>
                    <p class="des">
                        {{ increaseName }}
                    </p>
                </div>

                <!-- 添加自选 -->
                <template v-if="btnType === 'btn_type_txt'">
                    <div
                        class="addBtn btnTxt btnWatch btnWatch-sub-plus"
                        :class="'has-' + btnColor"
                        v-if="hasSubscribe"
                        @click="subscribeHandler"
                    >
                        <i class="plus"></i>
                        <span v-if="hasSubscribe" class="align-center">已添加</span>
                    </div>
                    <div class="addBtn btnTxt btnWatch" :class="btnColor" v-else @click="subscribeHandler">
                        <i class="plus"></i>
                        <span v-if="increaseTypeLang === 'cn'" class="align-center">添加自选</span>
                        <span v-else class="align-center">添加自選</span>
                    </div>
                </template>
                <!-- watchlist
                    :style="{ backgroundImage: `url(${buttonImageUrl})` }"-->
                <div
                    v-else-if="btnType === 'btn_type_watchlist_plus'"
                    class="addBtn btnWatch bgImg"
                    :class="[hasSubscribe ? 'btnWatch-sub-plus has-' + btnColor : btnColor]"
                    @click="subscribeHandler"
                >
                    <i class="plus"></i>
                    <!-- {{btnType}} -->
                    <p class="align-center">{{ hasSubscribe ? 'Added' : 'Watchlist' }}</p>
                </div>

                <div
                    v-else
                    class="addBtn btnWatch bgImg"
                    :class="[hasSubscribe ? 'btnWatch-sub has-' + btnColor : btnColor]"
                    @click="subscribeHandler"
                >
                    <i class="heart"></i>
                    <p class="align-center">{{ hasSubscribe ? 'Added' : 'Watchlist' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Ops from '../assets/script/constant';
import Toast from '@futuweb/future-ui/es/toast';
import '@futuweb/future-ui/es/toast/style/index.css';
import NNQ from '@futuweb/tool-nn/dist/nnq';
Toast.config({
    duration: 3,
    clickHide: false,
    withMask: false
});
// let lang;
let runBehaviour;
let uid = 0;
try {
    // lang = window.FEGORender.common.lang.isHK() ? 'hk' : 'cn';
    runBehaviour = window.FEGORender.common.behavior.runBehaviour;
    uid = window.FEGORender.store.variable.data.UID;
} catch (err) {
    // console.log(err);
}
const {
    common: {
        utils: { launchNN, launchMM },
        report: { record }
    }
} = window.FEGORender;
import useCommonApi from '../assets/script/request';
import { isNN, laterThanVersion } from '@futuweb/tool-browser';
const wchApi = useCommonApi('self-selected-stocks');
const quoteApi = useCommonApi('quote-small-card');
export default {
    name: 'quotes-small-card',
    props: {
        styleType: {
            type: String,
            default: '1'
        },
        showType: {
            type: String
        },
        stockCode: {
            type: String
        },
        stockId: {
            type: String
        },
        name: {
            type: String
        },
        highlights: {
            type: String
        },
        label: {
            type: String
        },
        skin: {
            type: String
        },
        labelColor: {
            type: String
        },
        increaseType: {
            type: String
        },
        btnType: {
            type: String
        },
        btnColor: {
            type: String
        },
        increaseTypeLang: {
            type: String
        },
        lang: {
            type: String,
            default: 'CN'
        },
        market: {
            type: String
        },
        ttmNote: {
            type: String
        },
        ttmDefault: {
            type: String
        },
        customText: {
            type: String
        },
        customNum: {
            type: String
        },
        app: {
            type: String,
            default: 'nn'
        },
        followApp: {
            type: Boolean,
            default: true
        },
        upColor: {
            type: String,
            default: '#F13E3A'
        },
        downColor: {
            type: String,
            default: '#00A843'
        }
    },
    data() {
        return {
            upDownType: -1, // 涨跌色设置
            chgData: 0, // 涨幅数据
            chgStr: '', // 涨跌字符串
            hasSubscribe: false, // 已经添加自选
            unloginTxt: '行情自选组件未登录点击上报'
            // stockId: '' // 股票ID
        };
    },
    created() {},
    computed: {
        // lang() {
        //     let str = 'en';
        //     if (window.FEGORender.common.lang.isCN()) {
        //         str = 'cn';
        //     } else if (window.FEGORender.common.lang.isHK()) {
        //         str = 'hk';
        //     }
        //     return str;
        // },
        increaseName() {
            switch (this.showType) {
                case Ops.showEnum.increase:
                    return Ops.increaseTypeOpt.get(this.increaseTypeLang).find((e) => e.value === this.increaseType)
                        .label;
                case Ops.showEnum['finacial-indicator']:
                    return this.ttmNote;
                case Ops.showEnum['custom']:
                    return this.customText;
                default:
                    return '';
            }
        },
        buttonImageUrl() {
            if (this.skin === 'skin-black') {
                if (this.hasSubscribe) {
                    return Ops.btnBgImgMap.get(`has_sub_${this.btnType}_btn_yellow`);
                } else {
                    return Ops.btnBgImgMap.get(`${this.btnType}_btn_yellow`);
                }
            }
            if (this.hasSubscribe) {
                return Ops.btnBgImgMap.get(`has_sub_${this.btnType}_${this.btnColor}`);
            } else {
                return Ops.btnBgImgMap.get(`${this.btnType}_${this.btnColor}`);
            }
        },
        rateStyle() {
            const { showType, chgData, increaseTypeLang } = this;

            if (chgData === 0) {
                return 'gray';
            }
            if (showType === Ops.showEnum['finacial-indicator']) {
                return 'red';
            }
            if (
                (chgData < 0 && increaseTypeLang === 'cn') ||
                (chgData > 0 && (increaseTypeLang === 'us' || increaseTypeLang === 'hk'))
            ) {
                return 'green';
            }

            return 'red';
        },
        dataStyle() {
            const { chgData, upDownType, upColor, downColor } = this;

            const gray = '#677DA1';
            const red = '#F13E3A';
            const green = '#00A843';
            const pink = '#F03A55';
            const transparent = 'transparent';

            let color = '';
            if (chgData === 0) {
                color = gray;
            } else if (upDownType === 0) {
                // 0-红涨绿跌
                color = chgData > 0 ? red : green;
            } else if (upDownType === 1) {
                // 1-绿涨红跌
                color = chgData > 0 ? green : red;
            } else if (upDownType === 2) {
                // 2-粉涨绿跌
                color = chgData > 0 ? pink : green;
            } else if (upDownType === 3) {
                // 3-绿涨粉跌
                color = chgData > 0 ? green : pink;
            } else if (chgData > 0 && upColor !== transparent) {
                // 未命中 upDownType 且有涨幅走 fego 涨色
                color = upColor;
            } else if (chgData < 0 && downColor !== transparent) {
                // 未命中 upDownType 且有跌幅走 fego 跌色
                color = downColor;
            }

            return color ? { color: `${color} !important` } : {};
        }
    },
    async mounted() {
        const initHandler = Ops.initHandlerMap[this.showType];
        // 设置了跟随客户端涨跌色，且客户端版本支持，则通过 jsbridge 去获取客户端涨跌色类型
        if (this.followApp && isNN() && !laterThanVersion('12.43.8908')) {
            this.initBridge();
        }
        if (initHandler) {
            await this[initHandler]();
        }
        try {
            if (uid !== 0) {
                this.requestGetOptionalStockSubscribeStatus();
            }
        } catch (err) {
            console.log('err', err);
            if (err && err.message) {
                Toast.fail(err.message, 2);
            } else {
                Toast.fail(err, 2);
            }
        }
    },
    methods: {
        // 初始化行情数据
        async initIncreaseData() {
            if (!this.stockCode || !this.increaseType) {
                Toast.fail('参数错误', 2);
                return;
            }
            // 从 k线去拉取数据
            try {
                const res = await quoteApi.get('increase-byk', {
                    stockId: this.stockId,
                    increaseType: this.increaseType
                });
                const { rate, rateStr } = res;
                this.chgData = rate;
                this.chgStr = rateStr;
            } catch (err) {
                console.log('err', err);
                if (err && err.message) {
                    Toast.fail(err.message, 2);
                } else {
                    Toast.fail(err, 2);
                }
            }
        },

        // 获取股票财务指标的股息率TTM
        async fetchFinacialIndicator() {
            const { stockId, market } = this;
            if (!stockId || !market) {
                Toast.fail('参数错误', 2);
                return;
            }

            try {
                const res = await quoteApi.get('finacial-indicator', {
                    stockId
                });
                console.log('fetch financial indicator-----:', res);
                const { dividendRatio } = res;
                this.chgData = dividendRatio;
                if (dividendRatio === 0) {
                    this.chgStr = this.ttmDefault;
                } else {
                    this.chgStr = `${(dividendRatio / 10 ** 2).toFixed(2)}%`;
                }
            } catch (err) {
                console.log('err', err);
                if (err && err.message) {
                    Toast.fail(err.message, 2);
                } else {
                    Toast.fail(err, 2);
                }
            }
        },
        customData() {
            this.chgData = parseInt(this.customNum);
            this.chgStr = this.customNum;
        },

        // 获取当前自选股订阅状态
        requestGetOptionalStockSubscribeStatus() {
            wchApi
                .get('status', {
                    stockId: this.stockId
                })
                .then((res) => {
                    this.hasSubscribe = res.data.result;
                })
                .catch((res) => {
                    console.log(res);
                });
        },
        // 订阅自选股
        requestSubscribeOptionalStock() {
            wchApi
                .post('subscribeStock', {
                    stockId: this.stockId
                })
                .then((res) => {
                    if (res.code === 10002) {
                        return this.toLogin();
                    }
                    this.hasSubscribe = true;
                })
                .catch((res) => {
                    console.log(res);
                });
        },
        // 解除订阅自选股
        requestUnsubscribeOptionalStock() {
            wchApi
                .post('cancelSubscribeStock', {
                    stockId: this.stockId
                })
                .then((res) => {
                    if (res.code === 10002) {
                        return this.toLogin();
                    }
                    this.hasSubscribe = false;
                })
                .catch((res) => {
                    console.log(res);
                });
        },
        // 订阅或解除订阅
        subscribeHandler(e) {
            // 需要特殊神策上报
            if (this.hasSubscribe) {
                runBehaviour(
                    this,
                    {
                        type: 'sdreport',
                        value: '添加自选'
                    },
                    e,
                    'optional-stock-card'
                );
                this.requestUnsubscribeOptionalStock();
            } else {
                runBehaviour(
                    this,
                    {
                        type: 'sdreport',
                        value: '已添加'
                    },
                    e,
                    'optional-stock-card'
                );
                this.requestSubscribeOptionalStock();
            }
        },
        // 跳登录页
        toLogin(e) {
            runBehaviour(
                this,
                {
                    type: 'login',
                    value: location.href,
                    withQuery: true
                },
                e,
                this.unloginTxt
            );
        },
        // 跳转到行情报价页
        jumpStockQuotePage($event) {
            const obj = {
                button_name: 'jumpStockQuotePage',
                $element_name: '跳转行情报价页按钮-quotes-small-card'
            };
            record($event, obj);

            const target = `quote/stockDetail/${this.stockID}/1`;
            let schema = `ftnn://${target}`;
            if (this.app === 'moomoo') {
                schema = `ftmm://${target}`;
                launchMM(schema);
                return;
            }
            launchNN(schema);
        },

        // 初始化牛牛NNWebViewJSBridge
        initBridge() {
            const me = this;
            NNQ.initBridge({}, () => {
                window.NNWebViewJSBridge.callHandler('getUpDownType', {}, (res) => {
                    try {
                        // result: 0 成功， -1失败
                        const ret = JSON.parse(res);
                        if (ret && ret.result === 0) {
                            //data: 涨跌色，0-红涨绿跌, 1-绿涨红跌, 2-粉涨绿跌, 3-绿涨粉跌
                            me.upDownType = ret.data;
                        }
                    } catch (e) {
                        console.error(e);
                    }
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import '../assets/less/index.less';
</style>
